<!--File: home.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/24/2017-->
<!--Desc: Template for the home page. -->
<!--Other Contributors:-->

<cgp-app-card titleText="Tool Progress Reporting" [showFullScreenToggle]="true">
    <div class="home-page-container"></div>
</cgp-app-card>